module.exports = __webpack_public_path__ + "img/service_pattern_02.44c120cb.png";